import { Application } from "@hotwired/stimulus"

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application

export { application }

// // Force cleanup of TinyMCE before Turbo caches the page or visits a new one
// document.addEventListener('turbo:before-cache', () => {
//   // 1. Remove all editor instances cleanly
//   if (typeof tinymce !== 'undefined') {
//     tinymce.remove();
//   }
//
//   // 2. Nuke the ghost sink element if it survived tinymce.remove()
//   //    (This specific element is what triggers the Firefox zoom crash)
//   document.querySelectorAll('.tox-tinymce-aux').forEach(el => el.remove());
// });
